
import * as handlebars_family from "../handlebars_family.ts";

const TPL = handlebars_family.addTemplate("feed/empty",{"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"fw-border1 fw-background-comment\" style=\"text-align:center;color:#bbb;font-size:18px\" data-fw-onclick=\"openPostPhoto\"><div class=\"fw-padding-responsive\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"empty_screens.activity",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":165},"end":{"line":1,"column":200}}})) != null ? stack1 : "")
    + "</div><img src=\"images/empty_state_illustration_gallery.svg\" style=\"width:200px\"></div>";
},"useData":true});
export default TPL;